import { render, staticRenderFns } from "./ProductReviews.vue?vue&type=template&id=26df67fe&scoped=true"
import script from "./ProductReviews.vue?vue&type=script&lang=js"
export * from "./ProductReviews.vue?vue&type=script&lang=js"
import style0 from "./ProductReviews.vue?vue&type=style&index=0&id=26df67fe&prod&scoped=true&lang=css"
import style1 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=1&prod&lang=css&external"
import style2 from "./ProductReviews.vue?vue&type=style&index=2&id=26df67fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26df67fe",
  null
  
)

export default component.exports